/* eslint-disable @typescript-eslint/explicit-function-return-type */
import axios from "axios";
import { getAccessToken } from "../../lib/auth/accessToken";

export { getAccessToken };

// Cropwise Yield Analysis service (EXP008), per environment: prod ->
// yield-analysis.prod, everything else -> yield-analysis.qa (the `dev` host the
// RFC documents has no DNS record). Deliberately has
// no default: falling back to a hardcoded host would make a misconfigured
// non-prod build read prod analytics data. Callers must treat an empty value as
// "yield analysis unavailable".
export const YIELD_ANALYSIS_API_URL =
  process.env.REACT_APP_YIELD_ANALYSIS_API_URL ?? "";

/*
 * No `Cache-Control` header on purpose. This service answers preflights with
 * `Access-Control-Allow-Headers: Content-Type,Authorization`, so sending one
 * makes the browser reject the request before it leaves — the trialing API
 * allows it, this one does not.
 */
export const YieldAnalysisAxiosInstance = axios.create({
  baseURL: YIELD_ANALYSIS_API_URL,
  headers: {
    Authorization: `Bearer ${getAccessToken()}`,
  },
});

YieldAnalysisAxiosInstance.interceptors.request.use(function (config) {
  // The token is re-read per request because it can be refreshed while the
  // app is open. `set` is Axios v1's own API for this: assigning to
  // `headers.Authorization` relies on AxiosHeaders' property proxy, and
  // replacing `headers` wholesale with a plain object drops that class.
  config.headers.set("Authorization", `Bearer ${getAccessToken()}`);
  return config;
});

export default YieldAnalysisAxiosInstance;
